import React, { useState } from 'react';

var Menu = (props) => {
  return (
    <ul className="menu">
      {
        React.Children.map(props.children, (child) => <li>{child}</li>)
      }
    </ul>
  )
}

var MenuItem = ({imageSrc, title, description, price}) => {
  return (
    <div className="menu-item">
      <img className="img-fluid" src={imageSrc} />
      <div className="menu-item-content">
        <div className="menu-item-content-header">
          <div className="menu-item-content-header-title">{title}</div>
          <div className="dots"></div>
          <div className="menu-item-content-header-price">{price}</div>
        </div>
        <div className="menu-item-content-header-description">{description}</div>
      </div>
    </div>
  )
}

export { Menu, MenuItem };
